import React from 'react';
import styled, { css } from '@emotion/native';
import { green, white } from '@/shared/styles/colors';
import { Feather } from '@expo/vector-icons';
import Button from '@/shared/components/Button';
import useBreakpoint from '@/shared/hooks/useBreakpoint';
import { StyleProp, ViewStyle } from 'react-native';

interface Props {
  canJoin: boolean;
  handleJoinCall: () => void;
  handleGoToChat: () => void;
  handleViewDetails: () => void;
  showDetails?: boolean;
  isChatButtonPrimaryStyle?: boolean;
  customButtonWidth?: number;
  isJoining: boolean;
  showEndButton?: boolean;
  handleEndSession?: () => void;
}

const ActionButtons = ({
  canJoin,
  handleJoinCall,
  handleGoToChat,
  handleViewDetails,
  showDetails = false,
  isChatButtonPrimaryStyle,
  customButtonWidth,
  isJoining = false,
  showEndButton = false,
  handleEndSession,
}: Props) => {
  const { isDesktop } = useBreakpoint();

  const buttonWidth: StyleProp<ViewStyle> = {
    width: isDesktop ? 145 : customButtonStyles.width,
  };

  if (customButtonWidth) {
    buttonWidth.width = customButtonWidth;
  }

  const buttonMargin = css({
    marginRight: isDesktop ? 9 : 0,
  });

  return (
    <StylistLinks isDesktop={isDesktop && showDetails}>
      {canJoin && !showEndButton && (
        <Button
          customStyle={[
            customButtonStyles,
            buttonWidth,
            { paddingTop: isDesktop ? 2 : 0 },
          ]}
          customLabelStyle={fontStyle}
          text="Join Call"
          onPress={handleJoinCall}
          variant="primary"
          leftIcon={
            <Feather
              name="video"
              size={20}
              color={white}
              style={{ marginRight: 6 }}
            />
          }
          loading={isJoining}
          disabled={isJoining}
        />
      )}
      {showEndButton && (
        <Button
          customStyle={[
            customButtonStyles,
            buttonWidth,
            { paddingTop: isDesktop ? 2 : 0 },
          ]}
          customLabelStyle={fontStyle}
          text="End Session"
          onPress={
            handleEndSession ||
            (() => console.log('End session handler not provided'))
          }
          variant="primary"
          loading={isJoining}
          disabled={isJoining}
        />
      )}
      <Button
        customStyle={[
          customButtonStyles,
          buttonWidth,
          buttonMargin,
          { paddingTop: isDesktop ? 4 : 0 },
        ]}
        customLabelStyle={fontStyle}
        text="View Chat"
        onPress={handleGoToChat}
        variant={isChatButtonPrimaryStyle ? 'primary' : 'tertiary'}
        leftIcon={
          <Image
            source={require('@/assets/images/ChatIcon.png')}
            style={{ width: 20, height: 20, marginRight: 6 }}
            tintColor={isChatButtonPrimaryStyle ? white : green}
          />
        }
      />
      {showDetails && (
        <Button
          customStyle={[customButtonStyles, buttonWidth, buttonMargin]}
          customLabelStyle={fontStyle}
          text="View Details"
          onPress={handleViewDetails}
          variant="tertiary"
        />
      )}
    </StylistLinks>
  );
};

const StylistLinks = styled.View<{ isDesktop: boolean }>(({ isDesktop }) => ({
  alignItems: 'center',
  flexDirection: isDesktop ? 'row-reverse' : 'column',
}));

const customButtonStyles = css({
  width: 325,
  marginBottom: 17,
  height: 42,
  borderWidth: 2,
});

const fontStyle = css({
  fontSize: 13,
  letterSpacing: -0.13,
  marginHorizontal: 0,
  marginLeft: 0,
  marginRight: 0,
});

const Image = styled.Image({
  width: 20,
  height: 20,
  marginRight: 6,
});

export default ActionButtons;
